'use strict';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import * as TASK_TYPE from '../../tasks/enums/TASK_TYPE';
import template from '../modals/add-file.html';

RequirementCreateModals.$inject = [
  '$modal',
];

// TODO: create openCreateFormRequirement method
export function RequirementCreateModals($modal) {

  const ctrlConfigs = {};
  ctrlConfigs[TASK_TYPE.SITE] = {
    taskType: TASK_TYPE.SITE,
    modelDomain: 'AssetTaskDomain',
  };
  ctrlConfigs[TASK_TYPE.PROJECT] = {
    taskType: TASK_TYPE.PROJECT,
    modelDomain: 'TaskDomain',
  };
  ctrlConfigs[TASK_TYPE.PROJECT_SITE] = {
    taskType: TASK_TYPE.PROJECT_SITE,
    modelDomain: 'TaskDomain',
  };

  this.openCreateFileRequirement = function openCreateFileRequirement(requirement, task, ctrlConfig) {
    const options = {
      template,
      controller: 'RequirementsFilesCreateController',
      animation: 'slide-in-up',
      locals: {
        ctrlConfig: Object.assign({}, ctrlConfigs[ctrlConfig.taskType], ctrlConfig),
        task: task,
        requirement: requirement,
      },
    };
    options.locals.ctrlConfig.header = getId(requirement)
      ? 'requirements.file.edit.subheader.label'
      : 'requirements.file.add.subheader.label';
    options.locals.ctrlConfig.domainClass = ctrlConfig.taskType === TASK_TYPE.SITE
      ? 'AssetFileRequirementDomain'
      : 'FileRequirementDomain';
    return $modal.show(options);
  };
}



// WEBPACK FOOTER //
// ./src/js/requirements/services/RequirementCreateModals.js